import { TextField, Typography } from '@material-ui/core';
import { useStyles } from './Form';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { finishOptions } from 'constants/finishing';

const Impeller = ({ control, watch, tableView }) => {
    const classes = useStyles();

    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Impeller</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.impellerQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '9%', marginRight: '1%'}}
            />
            <TextField
                label='Impeller Class'
                type='text'
                disabled={true}
                className={classes.disabledInput}
                variant='outlined' 
                InputLabelProps={{ shrink: true }} 
                size='small'
                value={watch('attributes.impellerClass')}
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.impellerBladeMaterial'
                type='text'
                control={control}
                label='Blade Material'
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.impellerShroudEyeMaterial'
                type='text'
                control={control}
                label='Shroud & Eye Material'
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.impellerBackplateMaterial'
                type='text'
                control={control}
                label='Backplate Material'
                style={{width: '14%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.impellerNotes'
                type='textarea'
                control={control}
                label='Notes'
                style={{width: '24%', marginRight: '1%'}}
                InputProps={{
                    multiline:true
                }}
            />
            <SelectWithDataReactHook
                name='attributes.impellerFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default Impeller;
